import styled from 'styled-components';
import { FadeLoader } from 'react-spinners';
import { fullLoadingStateRecoil } from '../atom/CommonAtom';
import { useRecoilValue } from 'recoil';

export function Spinner() {
  const loading = useRecoilValue(fullLoadingStateRecoil);

  if (!loading) {
    return null;
  }

  return (
    <Wrap>
      <FadeLoader
        color="#2869E2"
        loading={loading}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
    </Wrap>
  );
}

const Wrap = styled.div`
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #fff;
`;
